<template>
  <Filters
    ref="filtersRef"
    open-filter="openFilter"
  />
</template>

<script lang="ts" setup>
  import { ref, toRefs } from 'vue';
  import { useFiltersStore } from '@/app/features/ams/filters/filters-store';
  import { useClientStore } from '@/app/features/ams/client/client-store';
  import Filters from '@/app/features/ams/filters/FiltersView.vue';

  interface FiltersPageProps {
    filterId?: number;
    filterName?: string;
  }
  const props = defineProps<FiltersPageProps>();
  const filtersStore = useFiltersStore();
  const clientStore = useClientStore();
  const { filterId, filterName } = toRefs(props);
  const filtersRef = ref();

  if (filterId?.value && filterName?.value) {
    filtersStore.createFilterTab(clientStore.selectedClient.id, {
      name: filterName.value,
      id: filterId.value,
      isNew: false,
      dirtyTab: new Map<string, boolean>(),
    });
  }
</script>
